import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import { NAV_LINKS } from "../../data";

const SRI_AUROBINDO_SYMBOL = "https://upload.wikimedia.org/wikipedia/commons/1/1c/Sri-Aurobindos-Symbol.png";

export default function Nav() {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (href) => {
    if (location.pathname !== "/") navigate(`/${href}`);
    else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.nav
      data-testid="nav-main"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-12 inset-x-0 z-50 transition-all duration-500 ${solid ? "backdrop-blur-xl bg-sand/80 border-b border-borderln shadow-[0_8px_30px_rgba(140,98,33,0.06)]" : "bg-transparent"}`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[74px] flex items-center justify-between">
        <a data-testid="nav-logo-link" href="/" onClick={(e)=>{e.preventDefault();goTo("#top");}} className="flex items-center gap-2.5 group">
          <img data-testid="nav-sri-aurobindo-symbol" src={SRI_AUROBINDO_SYMBOL} alt="Sri Aurobindo's Symbol" className="w-8 h-8 object-contain" />
          <span className="font-display text-lg tracking-[0.18em] text-ink">AURO<span className="text-gold">·</span>VENTURES</span>
        </a>
        <div className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <button key={l.tid} data-testid={l.tid} onClick={() => goTo(l.href)}
              className="relative text-sm text-stoneink hover:text-ink transition-colors font-medium after:absolute after:left-0 after:-bottom-1.5 after:h-px after:w-0 after:bg-gold after:transition-all hover:after:w-full">
              {l.label}
            </button>
          ))}
        </div>
        <button data-testid="nav-cta-apply-button" onClick={() => goTo("#contact-form-section")}
          className="hidden sm:inline-flex items-center rounded-full bg-ink text-sand text-sm font-medium px-5 py-2.5 hover:bg-saffron transition-colors duration-300">
          Apply Now
        </button>
        <button className="md:hidden text-ink" onClick={()=>setOpen(!open)} data-testid="nav-mobile-toggle">
          <div className="w-6 space-y-1.5"><span className="block h-0.5 bg-ink"/><span className="block h-0.5 bg-ink"/><span className="block h-0.5 bg-ink w-4"/></div>
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-sand/95 backdrop-blur-xl border-t border-borderln px-6 py-4 space-y-3">
          {NAV_LINKS.map((l) => (
            <button key={l.tid} onClick={()=>{goTo(l.href);setOpen(false);}} className="block text-stoneink py-1">{l.label}</button>
          ))}
          <button onClick={()=>{goTo("#contact-form-section");setOpen(false);}} className="w-full rounded-full bg-ink text-sand py-2.5 mt-2">Apply Now</button>
        </div>
      )}
    </motion.nav>
  );
}
